import type { ModuleDTO } from '@/features/api/extranet/dto/Demande/CXPI'
import type { DemandeCxpi, DossierCxpi } from '@/features/api/extranet/dto/Dossier/Recherche/ReservationFonds'
import { getToday } from '@/features/shared/tools'
import { TypeModule } from '../../types/opco/Demande/CXPI'
import type { Statut } from '../../types/opco/Reservations-fonds/Dossier/Statut'

export function sortModules(modules: ModuleDTO[]): ModuleDTO[] {
  return [...modules].sort((a, b) => {
    // Tri par typeModule
    const indexA = a.typeModule ? TypeModule.indexOf(a.typeModule) : Number.MAX_SAFE_INTEGER
    const indexB = b.typeModule ? TypeModule.indexOf(b.typeModule) : Number.MAX_SAFE_INTEGER

    if (indexA !== indexB) {
      return indexA - indexB
    }

    // Tri par date de debu
    const dateA = a.dateDebut ? new Date(a.dateDebut).getTime() : Number.MAX_SAFE_INTEGER
    const dateB = b.dateDebut ? new Date(b.dateDebut).getTime() : Number.MAX_SAFE_INTEGER

    return dateA - dateB
  })
}

export function estDrfValide(dateFinValiditeDrf: Date, statut: Statut): boolean {
  return dateFinValiditeDrf >= getToday() && estDrfStatutValide(statut)
}

export function estDrfStatutValide(statut: Statut): boolean {
  return ['Accorde', 'RelanceAvantCloture'].includes(statut)
}

export function drfBrouillonsLies(demandes: DemandeCxpi[]): DemandeCxpi[] {
  return demandes?.filter((x) => ['SaisieAdherent', 'EnCoursDeTransmission'].includes(x.statut!)) ?? []
}

export function drfNbBrouillonsLies(demandes: DemandeCxpi[]): number {
  return drfBrouillonsLies(demandes).length ?? 0
}

export function drfNbDossiersLies(dossiersLies: DossierCxpi[]): number {
  return dossiersLies.length ?? 0
}

export function estDrfValideEtNbContratsAtteints(
  nombreContrats: number,
  dateFinValiditeDrf: Date,
  statut: Statut,
  demandes: DemandeCxpi[],
  dossiersLies: DossierCxpi[],
): boolean {
  return (
    nombreContrats! > drfNbBrouillonsLies(demandes) + drfNbDossiersLies(dossiersLies) &&
    estDrfValide(dateFinValiditeDrf, statut)
  )
}
